import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchLiveEvent, computeLiveStandings } from '../../utils/liveEvent';
import { categoryInfo } from '../../config/ratingCategories';
import { fmtDate } from '../../utils/weekUtils';

// ── UKURASA WA KUCHAPISHA / KUPAKUA PDF — Tukio la Papo Hapo ───────────
// Sawa na OfficeChessPrint: hakuna sidebar, "Print to PDF" ya kivinjari.
// "Mechi za Sasa" juu kabisa — hii ndiyo karatasi ya kubandika ukutani.

export default function LiveEventPrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLiveEvent(id).then(setEvent).catch(console.error).finally(() => setLoading(false));
  }, [id]);

  if (loading) return <div style={{ padding: '40px', fontFamily: 'sans-serif' }}>Inapakia...</div>;
  if (!event) return <div style={{ padding: '40px', fontFamily: 'sans-serif' }}>Tukio halikupatikana.</div>;

  const cat = categoryInfo(event.category);
  const isKnockout = event.pairingSystem === 'knockout';
  const standings = isKnockout ? [] : computeLiveStandings(event);
  const rounds = event.rounds || [];
  const latestRound = rounds[rounds.length - 1];

  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: '#F6F4EE', minHeight: '100vh', padding: '24px 16px' }}>
      <style>{`
        @media print {
          .no-print { display: none !important; }
          body { background: #fff !important; }
          .sheet { box-shadow: none !important; border: none !important; }
        }
      `}</style>

      <div className="no-print" style={{ maxWidth: '680px', margin: '0 auto 16px', display: 'flex', gap: '9px' }}>
        <button onClick={() => navigate(-1)} style={btnGhost}>← Rudi</button>
        <button onClick={() => window.print()} style={btn}>🖨️ Chapisha / Pakua PDF</button>
      </div>

      <div className="sheet" style={{
        maxWidth: '680px', margin: '0 auto', background: '#fff', borderRadius: '16px',
        border: '1px solid #E8E4DA', padding: '32px 28px',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div style={{ fontSize: '11px', letterSpacing: '2px', color: '#6B7280', fontWeight: 800 }}>
            IYANNA FOUNDATION RATING
          </div>
          <div style={{ fontFamily: "'Fraunces', Georgia, serif", fontSize: '24px', color: '#14452F', marginTop: '6px' }}>
            {event.title}
          </div>
          <div style={{ fontSize: '12px', color: '#6B7280', marginTop: '6px' }}>
            {cat.label} · Washindani {event.participants.length} · Raundi {rounds.length} kati ya {event.totalRounds || '—'}
            {event.status === 'finished' && event.winnerName ? ` · Mshindi: ${event.winnerName} 🏆` : ''}
          </div>
        </div>

        {/* MECHI ZA SASA — sehemu ya kubandika ukutani */}
        {latestRound && (
          <div style={{ marginBottom: '28px' }}>
            <div style={{
              fontSize: '12px', fontWeight: 800, color: '#fff', background: '#14452F',
              padding: '8px 14px', borderRadius: '9px', display: 'inline-block', marginBottom: '12px',
            }}>
              MECHI ZA RAUNDI {latestRound.number}
            </div>
            <div style={{ display: 'grid', gap: '8px' }}>
              {latestRound.pairings.map((p, i) => {
                const pending = !p.result;
                if (p.isBye) {
                  return (
                    <div key={i} style={{ fontSize: '12px', color: '#9CA3AF', padding: '8px 13px', background: '#FAF8F3', borderRadius: '10px' }}>
                      💤 {p.whiteName} — BYE
                    </div>
                  );
                }
                return (
                  <div key={i} style={{
                    display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 13px',
                    background: pending ? '#FAF8F3' : '#F9FAFB', border: '1px solid #E8E4DA', borderRadius: '10px',
                  }}>
                    <div style={{ flex: 1, fontSize: '13px', fontWeight: 700, color: '#1A1A1A' }}>
                      {p.whiteName} <span style={{ fontSize: '10px', color: '#9CA3AF', fontWeight: 600 }}>(Weupe)</span>
                    </div>
                    <div style={{ fontSize: '12px', fontWeight: 800, color: pending ? '#D97706' : '#14452F', minWidth: '46px', textAlign: 'center' }}>
                      {pending ? 'BADO' : p.result}
                    </div>
                    <div style={{ flex: 1, fontSize: '13px', fontWeight: 700, color: '#1A1A1A', textAlign: 'right' }}>
                      <span style={{ fontSize: '10px', color: '#9CA3AF', fontWeight: 600 }}>(Weusi) </span>{p.blackName}
                    </div>
                  </div>
                );
              })}
            </div>
            {latestRound.byeName && (
              <div style={{ fontSize: '11.5px', color: '#9CA3AF', marginTop: '9px' }}>
                💤 Bye raundi hii: {latestRound.byeName}
              </div>
            )}
          </div>
        )}

        {!isKnockout && (
          <>
            <div style={{ fontSize: '13px', fontWeight: 800, color: '#14452F', marginBottom: '11px' }}>
              Standings
            </div>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13.5px' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #14452F' }}>
                  <th style={thP}>#</th>
                  <th style={{ ...thP, textAlign: 'left' }}>Jina</th>
                  <th style={thP}>Pointi</th>
                  <th style={thP}>W</th>
                  <th style={thP}>S</th>
                  <th style={thP}>L</th>
                </tr>
              </thead>
              <tbody>
                {standings.map((s, i) => (
                  <tr key={s.id} style={{ borderBottom: '1px solid #E8E4DA' }}>
                    <td style={{ ...tdP, textAlign: 'center', fontWeight: 800, color: i === 0 ? '#B45309' : '#6B7280' }}>{i + 1}</td>
                    <td style={{ ...tdP, fontWeight: 700 }}>{s.name}{i === 0 && s.games > 0 ? ' 🏆' : ''}</td>
                    <td style={{ ...tdP, textAlign: 'center', fontWeight: 800, color: '#14452F' }}>{s.points}</td>
                    <td style={{ ...tdP, textAlign: 'center', color: '#6B7280' }}>{s.wins}</td>
                    <td style={{ ...tdP, textAlign: 'center', color: '#6B7280' }}>{s.draws}</td>
                    <td style={{ ...tdP, textAlign: 'center', color: '#6B7280' }}>{s.losses}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {rounds.length > 0 && (
          <div style={{ marginTop: '26px' }}>
            <div style={{ fontSize: '13px', fontWeight: 800, color: '#14452F', marginBottom: '10px' }}>
              Matokeo ya Raundi Zote
            </div>
            {rounds.map(r => (
              <div key={r.number} style={{ marginBottom: '12px' }}>
                <div style={{ fontSize: '11.5px', fontWeight: 700, color: '#6B7280', marginBottom: '4px' }}>
                  Raundi {r.number}
                </div>
                {r.pairings.map((p, i) => (
                  <div key={i} style={{ fontSize: '12.5px', color: '#1A1A1A', padding: '3px 0' }}>
                    {p.isBye ? (
                      <>{p.whiteName} <span style={{ color: '#9CA3AF', fontSize: '10.5px' }}>BYE</span></>
                    ) : (
                      <>
                        {p.whiteName} <span style={{ color: '#9CA3AF', fontSize: '10.5px' }}>(Weupe)</span>{' '}
                        <span style={{ color: p.result ? '#9CA3AF' : '#D97706', fontWeight: p.result ? 400 : 700 }}>
                          {p.result || 'bado'}
                        </span>{' '}
                        {p.blackName} <span style={{ color: '#9CA3AF', fontSize: '10.5px' }}>(Weusi)</span>
                      </>
                    )}
                  </div>
                ))}
                {r.byeName && (
                  <div style={{ fontSize: '11.5px', color: '#9CA3AF' }}>Bye: {r.byeName}</div>
                )}
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: '26px', paddingTop: '14px', borderTop: '1px solid #E8E4DA', fontSize: '10.5px', color: '#9CA3AF', textAlign: 'center' }}>
          Imetolewa {fmtDate(new Date())} · Iyanna Foundation
        </div>
      </div>
    </div>
  );
}

const btn = {
  background: 'linear-gradient(135deg, #14452F, #1F6B45)', color: '#fff', border: 'none',
  padding: '11px 18px', borderRadius: '10px', fontSize: '13px', fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit',
};
const btnGhost = {
  background: '#fff', color: '#14452F', border: '1px solid #E8E4DA',
  padding: '11px 16px', borderRadius: '10px', fontSize: '13px', fontWeight: 700,
  cursor: 'pointer', fontFamily: 'inherit',
};
const thP = { padding: '8px 6px', fontSize: '10.5px', color: '#6B7280', fontWeight: 800, textAlign: 'center' };
const tdP = { padding: '9px 6px' };
